import { createFileRoute } from "@tanstack/react-router";

import { BankConnections } from "@/features/settings/bank";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_settings/einstellungen/bank",
)({
  component: Banks,
});

function Banks() {
  return <BankConnections />;
}
